export enum UserRoles {
    USER = "user",
    ORGANIZER = "organizer",
    ADMIN = "admin",
}

export enum NotificationFrequency {
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    HOURLY = 'hourly',
    TEN_MINUTE = '10minute',
    DAILY = "daily",
    NEVER = "never",
}

export enum NotificationMethod {
    EMAIL = 'email',
    PUSH = 'push',
    BROWSER = 'browser',
    BOTH = 'both',
}

export enum NotificationDay {
    MONDAY = 'monday',
    TUESDAY = 'tuesday',
    WEDNESDAY = 'wednesday',
    THURSDAY = 'thursday',
    FRIDAY = 'friday',
    SATURDAY = 'saturday',
    SUNDAY = 'sunday',
}

export enum UserStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    SUSPENDED = 'suspended',
}
